import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getAllDataTypes, getDataTypeMappings, loadAllDataTypeMappings, loadAllDataTypes } from "../../store/dataTypes";
import XMLParser from "react-xml-parser";
import { getFieldData } from "../../../services/appService";
import { generatedContractReceived, getGeneratedDocument, loadGenerateContractDocument } from "../../store/ddrmsDocument";
import AddDataTypeMapping from "./AddDataTypeMapping";
import moment from "moment";
import { getLocalDocUploadSasUrl, getLocalGeneratedDocUploadSasUrl, uploadGeneratedLocalDocument, uploadLocalDocument } from "../../store/documents";
import { getCurrentUser } from "../../store/auth";
import { get, set, size } from "lodash";
import { getAlert } from "../../../services/appAlerts";
import { uploadFileToBlob } from "../../../services/blobUploadService";

const DataMapping = (props) => {
    const { app, handleCloseMapping, selectedObj, workflowTask, applicantObj, uploadType, viewType, defaultMappingId, autoSave = false, deferSave = false, initialGeneratedData = null, onStageGenerated = null, bodyOnly = false } = props;
    const [allMapObjects, setAllMapObjects] = useState([]);
    const [selectedMappingId, setSelectedMappingId] = useState("");
    const [dataTypeMapping, setDataTypeMapping] = useState([]);
    const [newMappingShowHide, setNewMappingShowHide] = useState(false);
    const [btnProcessStatus, setBtnProcessStatus] = useState(false);
    const [saveBtnType, setSaveBtnType] = useState("");
    const [generatedBlob, setGeneratedBlob] = useState(null);
    const [activePopoverField, setActivePopoverField] = useState(null);
    const [mappingReady, setMappingReady] = useState(false);
    const autoSaveStartedRef = useRef(false);


    const getGeneratedDocumentSelector = useSelector(getGeneratedDocument);
    const dataTypeMappingsSelector = useSelector(getDataTypeMappings);
    const localGeneratedDocUploadSasUrlSelector = useSelector(getLocalGeneratedDocUploadSasUrl);

    const dispatch = useDispatch();
    const currentUser = useSelector(getCurrentUser);

    const normalizeToPdfBlob = (doc) => {
        if (!doc) return null;
        if (doc instanceof Blob) {
            if (doc.type) return doc;
            return new Blob([doc], { type: "application/pdf" });
        }
        if (doc?.data instanceof Blob) {
            if (doc.data.type) return doc.data;
            return new Blob([doc.data], { type: "application/pdf" });
        }
        return new Blob([doc], { type: "application/pdf" });
    };

    useEffect(() => {
        dispatch(loadAllDataTypeMappings());
    }, []);

    useEffect(() => {
        let perfId = 0;
        let perfType = "";
        if (uploadType === "Subcontractor") {
            perfType = "Sub-Contractors"
        }
        else if (uploadType === "Candidate") {
            perfType = "candidate"
        } else if (uploadType === "Recruiter") {
            perfType = "Recruiter"
        }
        setDataTypeMapping(dataTypeMappingsSelector.filter(x => x.type === perfType));
    }, [dataTypeMappingsSelector])

    const handleGenerate = (btnType) => {
        setBtnProcessStatus(true);
        setSaveBtnType(btnType);
        var mapData = {};
        allMapObjects.map(item => {
            let ddValue = "";
            item.replaceDataTypes.filter(x => x.attValue !== "").map(v => {
                ddValue += v.attValue + (v.attCommaSeperated ? ", " : " ");
            });
            mapData[item.field] = ddValue;
        })
        var frmData = new FormData();
        frmData.append("ciid", workflowTask.ciid);
        frmData.append("docId", selectedObj.id);
        frmData.append("mapData", JSON.stringify(mapData));
        frmData.append("btnType", btnType);
        dispatch(loadGenerateContractDocument(frmData));
    }

    useEffect(() => {
        if (getGeneratedDocumentSelector) {
            let newFileName = "ipcs_document";
            if (selectedObj?.name)
                newFileName = selectedObj.name.replace(/\.docx$/, ".pdf");
            const normalizedBlob = normalizeToPdfBlob(getGeneratedDocumentSelector);
            if (!normalizedBlob || normalizedBlob.size === 0) {
                getAlert("Error", "Generated document is empty. Please try again.", "error");
                dispatch(generatedContractReceived(null));
                setBtnProcessStatus(false);
                setSaveBtnType("");
                return;
            }
            if (saveBtnType === "save") {
                const file = new File([normalizedBlob], newFileName, { type: normalizedBlob.type || "application/pdf" });
                if (deferSave && onStageGenerated) {
                    onStageGenerated({ file, fileName: newFileName });
                    setSaveBtnType("");
                    handleCloseMapping("stage");
                } else {
                    setGeneratedBlob(file);
                    saveLocalDocs(workflowTask, normalizedBlob, newFileName);
                }
            }
            else
                downloadGeneratedDocument(normalizedBlob, newFileName);

            dispatch(generatedContractReceived(null));
            setBtnProcessStatus(false);
            //setSaveBtnType("");
        }
    }, [getGeneratedDocumentSelector]);

    const saveLocalDocs = (workflowTask, blob, fileName) => {
        let wfTask = { ...workflowTask };
        if (viewType === "candidateList") {
            if (uploadType === "Recruiter" && applicantObj?.recruiter?.parentid)
                wfTask.performerId = applicantObj.recruiter.parentid
            else if (uploadType === "Subcontractor" && applicantObj?.subcontractor?.parentid)
                wfTask.performerId = applicantObj.subcontractor.parentid
            else if (uploadType === "Candidate" && applicantObj?.id)
                wfTask.performerId = applicantObj?.id
        }
        else if (applicantObj?.id) {
            wfTask.performerId = applicantObj?.id
        }

        const frmData = new FormData();
        frmData.append("message", "contract generated");
        frmData.append("workflowTask", JSON.stringify(wfTask));
        frmData.append("userId", currentUser.id);
        frmData.append('files', JSON.stringify([{ name: fileName, type: blob.type, size: blob.size }]));
        frmData.append("docType", "");
        frmData.append("updType", "");
        frmData.append("isPwd", "");
        dispatch(uploadGeneratedLocalDocument(frmData));
        if (!autoSave) getAlert("", "Contract generated successfully", "success");
    }

    useEffect(() => {
        if (localGeneratedDocUploadSasUrlSelector && localGeneratedDocUploadSasUrlSelector?.length > 0 && generatedBlob) {
            const completedType = saveBtnType;
            const uploadGeneratedBlob = async () => {
                const uploaded = await uploadFileToBlob(
                    generatedBlob,
                    localGeneratedDocUploadSasUrlSelector[0]?.uploadUrl
                );

                setGeneratedBlob(null);
                setSaveBtnType("");
                if (uploaded) {
                    handleCloseMapping(completedType);
                } else {
                    getAlert("Error", "Generated document upload failed. Please try again.", "error");
                    handleCloseMapping("");
                }
            };
            uploadGeneratedBlob();
        }
    }, [localGeneratedDocUploadSasUrlSelector]);

    const downloadGeneratedDocument = (blob, fileName) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        getAlert("", "Document downloaded successfully, Check your downlaod folder", "success");
        handleCloseMapping(saveBtnType);
    }

    const handleAddNewMapping = () => {
        setNewMappingShowHide(!newMappingShowHide);
    }

    const compileMapping = (profileId) => {
        const ddMaps = dataTypeMapping.filter(x => x.id === parseInt(profileId));
        if (ddMaps.length > 0) {
            const mpJs = JSON.parse(ddMaps[0].mappingJson);
            let att = "";
            let vl = "";
            if (applicantObj.partnerType) {
                att = applicantObj.partnerType;
                vl = applicantObj.fuid;
            }
            else {
                att = applicantObj.registrationType;
                vl = applicantObj.id;
            }

            const updMpjs = mpJs.map(x => {
                x.replaceDataTypes.map(d => {
                    if (d.attType === "currentDate" && d.attObj === "date") {
                        d.attValue = moment(new Date()).format("MM-DD-YYYY");
                    }
                    else if (d.attType === att && d.attObj === "id") {
                        d.attValue = vl;
                    }
                    else {
                        if (applicantObj.applications.length > 0) {
                            const appObj = applicantObj.applications[0];
                            const attValue = getFieldData(appObj.applicationData, d.attType.toLowerCase(), d.attObj);
                            d.attValue = attValue;
                        }
                        else {
                            d.attValue = "";
                        }
                    }
                    return d;
                })
                return x;
            })
            setAllMapObjects(updMpjs)
            setMappingReady(true);
        }
    };

    const handleChangeMapping = ({ currentTarget }) => {
        const val = currentTarget.value;
        setSelectedMappingId(val);
        compileMapping(val);
    }

    useEffect(() => {
        if (defaultMappingId && dataTypeMapping.length > 0) {
            setMappingReady(false);
            setSelectedMappingId(defaultMappingId.toString());
            compileMapping(defaultMappingId);
        }
    }, [defaultMappingId, dataTypeMapping]);

    useEffect(() => {
        if (
            autoSave &&
            initialGeneratedData?.file &&
            workflowTask?.ciid > 0 &&
            !autoSaveStartedRef.current
        ) {
            const stagedFile = initialGeneratedData.file;
            autoSaveStartedRef.current = true;
            setSaveBtnType("save");
            setGeneratedBlob(stagedFile);
            saveLocalDocs(workflowTask, stagedFile, initialGeneratedData.fileName || stagedFile.name);
        }
    }, [autoSave, initialGeneratedData, workflowTask]);

    useEffect(() => {
        if (
            autoSave &&
            !initialGeneratedData?.file &&
            mappingReady &&
            selectedMappingId &&
            workflowTask?.ciid > 0 &&
            selectedObj?.id > 0 &&
            !autoSaveStartedRef.current
        ) {
            autoSaveStartedRef.current = true;
            handleGenerate("save");
        }
    }, [autoSave, mappingReady, selectedMappingId, workflowTask, selectedObj]);

    const handleDeleteMappItem = (item) => {
        const ddMapps = [...allMapObjects];
        const index = ddMapps.findIndex(x => x.field === item.field);
        if (index > -1) {
            ddMapps.splice(index, 1);
            setAllMapObjects(ddMapps);
        }
    }

    const getCompiledValue = (item) => {
        let compiled = "";
        item.replaceDataTypes.filter(x => x.attValue !== "").map(v => {
            compiled += v.attValue + (v.attCommaSeperated ? ", " : " ");
        });
        return compiled.trim();
    }

    const togglePopover = (field) => {
        setActivePopoverField(activePopoverField === field ? null : field);
    }

    return <>
        <style>{`
            .dm-wrap,
            .dm-wrap button,
            .dm-wrap input,
            .dm-wrap select,
            .dm-wrap textarea {
                font-family: "Open Sans", sans-serif !important;
            }
            .dm-wrap {
                display: flex;
                flex-direction: column;
                gap: 20px;
                animation: dmFadeIn 0.3s ease both;
            }
            @keyframes dmFadeIn {
                from { opacity: 0; transform: translateY(8px); }
                to { opacity: 1; transform: translateY(0); }
            }
            .dm-control-group {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }
            .dm-control-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
            }
            .dm-label {
                font-size: 12px;
                font-weight: 600;
                color: #475569;
                text-transform: uppercase;
                letter-spacing: 0.04em;
                margin: 0;
            }
            .dm-add-btn {
                background: none;
                border: none;
                color: #2563eb;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                padding: 0;
                transition: color 0.15s ease;
                display: inline-flex;
                align-items: center;
                gap: 4px;
            }
            .dm-add-btn:hover {
                color: #1d4ed8;
                text-decoration: underline;
            }
            .dm-select {
                width: 100%;
                min-height: 40px;
                padding: 8px 12px;
                border-radius: 0 !important;
                border: 1px solid #cbd5e1;
                background-color: #ffffff;
                color: #1e293b;
                font-size: 13.5px;
                font-weight: 400;
                transition: all 0.15s ease;
                cursor: pointer;
                outline: none;
            }
            .dm-select:focus {
                border-color: #2563eb;
                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
            }
            .dm-card-list-wrapper {
                max-height: 480px;
                overflow-y: auto;
                padding-right: 0;
                position: relative;
                scrollbar-width: thin;
                scrollbar-color: #cbd5e1 transparent;
            }
            .dm-card-list-wrapper::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            .dm-card-list-wrapper::-webkit-scrollbar-track {
                background: transparent;
            }
            .dm-card-list-wrapper::-webkit-scrollbar-thumb {
                background: #cbd5e1;
                border-radius: 0;
            }
            .dm-card-list-wrapper::-webkit-scrollbar-thumb:hover {
                background: #94a3b8;
            }
            .dm-card-list {
                display: flex;
                flex-direction: column;
                gap: 0;
            }
            .dm-mapping-card {
                background: #ffffff;
                border: 0;
                border-bottom: 1px solid #e2e8f0;
                border-radius: 0 !important;
                box-shadow: none !important;
                transition: all 0.15s ease;
            }
            .dm-mapping-card:hover {
                background: #f8fafc;
                border-bottom-color: #cbd5e1;
            }
            .dm-card-main {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 14px 18px;
                position: relative;
            }
            .dm-card-info {
                display: flex;
                align-items: center;
                gap: 16px;
                flex: 1;
                min-width: 0;
            }
            .dm-field-badge {
                font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
                font-size: 12.5px;
                font-weight: 700;
                color: #0f172a;
                background: #f1f5f9;
                padding: 4px 10px;
                border-radius: 0 !important;
                border: 1px solid #cbd5e1;
                white-space: nowrap;
            }
            .dm-value-display {
                display: flex;
                align-items: center;
                gap: 8px;
                min-width: 0;
                flex: 1;
            }
            .dm-value-label {
                font-size: 11px;
                font-weight: 800;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }
            .dm-value-text {
                font-weight: 700;
                color: #0369a1;
                background: #f0f9ff;
                border: 1px solid #e0f2fe;
                padding: 4px 12px;
                border-radius: 0 !important;
                font-size: 13px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 100%;
            }
            .dm-value-empty {
                color: #94a3b8;
                font-style: italic;
                font-weight: 500;
                background: transparent;
                border: none;
                padding: 0;
            }
            .dm-card-actions {
                display: flex;
                align-items: center;
                gap: 8px;
                position: relative;
            }
            .dm-action-btn {
                min-height: 32px;
                height: 32px;
                background: #ffffff;
                border: 1px solid #cbd5e1;
                color: #1e293b;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                padding: 0 12px;
                border-radius: 0 !important;
                transition: all 0.15s ease;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                outline: none !important;
                box-sizing: border-box;
                line-height: 1;
            }
            .dm-action-btn:hover {
                background: #f8fafc;
                border-color: #94a3b8;
                color: #0f172a;
                transform: translateY(-1px);
            }
            .dm-action-btn.delete {
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #ef4444;
                padding: 0;
                width: 32px;
                min-width: 32px;
                height: 32px;
                min-height: 32px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
            }
            .dm-action-btn.delete:hover {
                background: #fef2f2;
                color: #dc2626;
                border-color: #ef4444;
                transform: translateY(-1px);
            }
            .dm-action-btn.datatype {
                height: 32px;
                min-height: 32px;
                background: #ffffff;
                border-color: #cbd5e1;
                color: #1e293b;
                padding: 0 12px;
                box-sizing: border-box;
            }
            .dm-action-btn.datatype:hover, .dm-action-btn.datatype.active {
                background: #f8fafc;
                border-color: #94a3b8;
                color: #0f172a;
                transform: translateY(-1px);
            }
            .dm-card-details {
                border-top: 1px solid #e2e8f0;
                background: #f8fafc;
                padding: 12px 18px;
                animation: slideDown 0.2s cubic-bezier(0.16, 1, 0.3, 1) both;
            }
            @keyframes slideDown {
                from { opacity: 0; transform: translateY(-4px); }
                to { opacity: 1; transform: translateY(0); }
            }
            .dm-details-header {
                font-size: 11px;
                font-weight: 800;
                color: #64748b;
                text-transform: uppercase;
                letter-spacing: 0.05em;
                margin-bottom: 8px;
                display: flex;
                align-items: center;
                gap: 6px;
                text-align: left;
            }
            .dm-details-header i {
                color: #2563eb;
            }
            .dm-details-body {
                display: flex;
                flex-direction: column;
                gap: 8px;
            }
            .dm-details-row {
                display: grid;
                grid-template-columns: minmax(180px, 1fr) 36px minmax(150px, 1fr);
                align-items: center;
                padding: 6px 12px;
                background: #ffffff;
                border: 1px solid #e2e8f0;
                border-radius: 0 !important;
                text-align: left;
            }
            .dm-details-source {
                font-size: 12.5px;
                font-weight: 600;
                color: #334155;
                display: inline-flex;
                align-items: center;
                gap: 6px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .dm-details-source i {
                color: #3b82f6;
                font-size: 11px;
            }
            .dm-details-arrow {
                color: #94a3b8;
                font-size: 12px;
                justify-self: center;
            }
            .dm-details-val {
                font-size: 12.5px;
                font-weight: 700;
                color: #0284c7;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .dm-details-val-badge {
                background: #f0f9ff;
                color: #0369a1;
                border: 1px solid #e0f2fe;
                padding: 2px 8px;
                border-radius: 0 !important;
                display: inline-block;
            }
            .dm-details-val-empty {
                color: #94a3b8;
                font-style: italic;
                font-weight: 500;
            }
            .dm-actions-footer {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 12px;
                flex-wrap: wrap;
                margin-top: 10px;
                padding-top: 20px;
                border-top: 1px solid #f1f5f9;
            }
            .dm-btn {
                min-height: 36px;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                padding: 7px 16px;
                border-radius: 0 !important;
                font-size: 13px;
                font-weight: 500;
                cursor: pointer;
                transition: all 0.15s ease;
                white-space: nowrap;
                border: 1px solid #cbd5e1;
                background: #ffffff;
                color: #1e293b;
                box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
            }
            .dm-btn:hover:not(:disabled) {
                background: #f8fafc;
                border-color: #94a3b8;
                transform: translateY(-1px);
            }
            .dm-btn:disabled {
                opacity: 0.6;
                cursor: not-allowed;
            }
            .dm-btn.primary {
                background: #2563eb;
                border-color: #2563eb;
                color: #ffffff;
                box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2);
            }
            .dm-btn.primary:hover:not(:disabled) {
                background: #1d4ed8;
                border-color: #1d4ed8;
                color: #ffffff;
            }
            .dm-btn.secondary {
                background: #ffffff;
                border-color: #cbd5e1;
                color: #1e293b;
            }
            .dm-btn.secondary:hover:not(:disabled) {
                background: #f8fafc;
                border-color: #94a3b8;
            }
        `}</style>

        {!newMappingShowHide && (
            <div className="dm-wrap">
                <div className="dm-control-group">
                    <div className="dm-control-header">
                        <label htmlFor="ddMapping" className="dm-label">Existing DataType Mapping</label>
                    </div>
                    <select
                        className="dm-select"
                        name="ddMapping"
                        id="ddMapping"
                        value={selectedMappingId}
                        onChange={handleChangeMapping}
                    >
                        <option value="">Select a mapping profile...</option>
                        {dataTypeMapping.map(x =>
                            <option key={x.id} value={x.id}>{x.name}</option>
                        )}
                    </select>
                </div>

                {allMapObjects.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '36px', color: '#64748b', background: '#f8fafc', borderRadius: '10px', border: '1px dashed #cbd5e1' }}>
                        <div style={{ fontSize: '24px', marginBottom: '8px', color: '#cbd5e1' }}><i className="fa fa-database" /></div>
                        <h5 style={{ fontWeight: 800, color: '#0f172a' }}>No Fields Mapped</h5>
                        <p style={{ margin: 0, fontSize: '13px' }}>Select an existing DataType Mapping profile above to load mappings.</p>
                    </div>
                ) : (
                    <div className="dm-card-list-wrapper">
                        <div className="dm-card-list">
                            {allMapObjects.map((item) => (
                                <div key={item.field} className="dm-mapping-card">
                                    <div className="dm-card-main">
                                        <div className="dm-card-info">
                                            <span className="dm-value-label">Field:</span>
                                            <span className="dm-field-badge">{item.field}</span>
                                            <div className="dm-value-display">
                                                <span className="dm-value-label">Value:</span>
                                                <span className="dm-value-text">
                                                    {getCompiledValue(item) || <span className="dm-value-empty">No value mapped</span>}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="dm-card-actions">
                                            <button 
                                                type="button" 
                                                className={`dm-action-btn datatype ${activePopoverField === item.field ? 'active' : ''}`}
                                                onClick={() => togglePopover(item.field)}
                                                title="View mapped datatypes"
                                            >
                                                <i className="fa fa-database" />
                                                <span>Datatype</span>
                                            </button>
                                            <button 
                                                type="button" 
                                                className="dm-action-btn delete"
                                                onClick={() => handleDeleteMappItem(item)}
                                                title="Delete mapping"
                                            >
                                                <i className="fa fa-trash-o" />
                                            </button>
                                        </div>
                                    </div>
                                    {activePopoverField === item.field && (
                                        <div className="dm-card-details">
                                            <div className="dm-details-header">
                                                <i className="fa fa-link" /> Mapped Datatypes & Fields
                                            </div>
                                            <div className="dm-details-body">
                                                {item.replaceDataTypes.map((m, idx) => (
                                                    <div key={idx} className="dm-details-row">
                                                        <div className="dm-details-source" title={`${m.attType}.${m.attObj}`}>
                                                            <span>{m.attType}.{m.attObj}</span>
                                                        </div>
                                                        <div className="dm-details-arrow">
                                                            <i className="fa fa-long-arrow-right" />
                                                        </div>
                                                        <div className="dm-details-val" title={m.attValue || 'Empty'}>
                                                            {m.attValue ? (
                                                                <span className="dm-details-val-badge">{m.attValue}</span>
                                                            ) : (
                                                                <span className="dm-details-val-empty">No value available</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="dm-actions-footer">
                    {!bodyOnly && <button type="button" className="dm-btn" onClick={props.goBack}>
                        <i className="fa fa-arrow-left" /> Back
                    </button>}
                    
                    <button 
                        type="button" 
                        className="dm-btn secondary"
                        disabled={allMapObjects.length === 0 || btnProcessStatus}
                        onClick={() => handleGenerate("generate")}
                    >
                        {btnProcessStatus && saveBtnType === "generate" ? (
                            <i className="fa fa-spinner fa-spin" />
                        ) : (
                            <i className="fa fa-download" />
                        )}
                        &nbsp;Generate & Download (PDF)
                    </button>

                    <button 
                        type="button" 
                        className="dm-btn primary"
                        disabled={allMapObjects.length === 0 || btnProcessStatus}
                        onClick={() => handleGenerate("save")}
                    >
                        {btnProcessStatus && saveBtnType === "save" ? (
                            <i className="fa fa-spinner fa-spin" />
                        ) : (
                            <i className="fa fa-cloud-upload" />
                        )}
                        &nbsp;{deferSave ? "Generate & Save Locally (PDF)" : "Generate & Save to DDRMS (PDF)"}
                    </button>
                </div>
            </div>
        )}

        {newMappingShowHide && <AddDataTypeMapping app={app} applicantObj={applicantObj} handleAddNewMapping={handleAddNewMapping} />}
    </>

}

export default DataMapping;
